import { IPanelColumnDetails } from '../types';
import EntityDetails from '../details/EntityDetails';
import { getSelectableNodeKey } from '../utils';
import { DetailsCol } from '../EntitySelectionPanelUI';
import React from 'react';

const DetailsPanel = ({ panel }: { panel: IPanelColumnDetails }) => {
  const { node } = panel;
  return (
    <DetailsCol>
      <EntityDetails
        node={node}
        // ensures that the component is remounted if the entity changes, it will trigger
        // reloading the details
        key={getSelectableNodeKey(node)}
      />
    </DetailsCol>
  );
};
export default DetailsPanel;
